// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const WINDOW_FUNCTIONS_STEP_SHAPES = [
  {
    stepType: PipelineStepType.WINDOW_FUNCTIONS,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      windows: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'aggregationFunction',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'AVERAGE'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'COUNT'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'COUNT_NULLS'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'MAX'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'MEDIAN'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'MIN'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'MODE'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'PRODUCT'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'STANDARD_DEVIATION'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'STANDARD_ERROR'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'SUM'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'VARIANCE'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'FIRST'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'LAG'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'LAST'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'LEAD'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  allowMissingColumn: false,
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'CUME_DIST'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'DENSE_RANK'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'PERCENT_RANK'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'RANK'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'ROW_NUMBER'
                },
                newColumnName: {
                  kind: 'string',
                  required: true
                },
                partitionColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    allowMissingColumn: false,
                    validationOptions: null
                  }
                },
                orderByColumns: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      column: {
                        kind: 'columnReference',
                        required: true,
                        inputDataName: 'Input dataset',
                        allowMissingColumn: false,
                        validationOptions: null
                      },
                      direction: {
                        kind: 'enum',
                        required: true,
                        choices: [
                          'ASCENDING',
                          'DESCENDING'
                        ]
                      }
                    }
                  }
                }
              }
            }
          ]
        },
        minItems: 1
      },
      orderByColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            column: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Input dataset',
              allowMissingColumn: false,
              validationOptions: null
            },
            direction: {
              kind: 'enum',
              required: true,
              choices: [
                'ASCENDING',
                'DESCENDING'
              ]
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
